<template>
    <table class="table table-sm table-hover">
        <thead v-if="header">
        <tr>
            <th v-for="headerColumn in header">
                {{ headerColumn }}
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(value, key) in data">
            <td :class="keyClass">
                {{ getTransformedKey(key) }}
                <span v-if="colons">:</span>
            </td>
            <td :class="valueClass">
                {{ value ? getTransformedValue(value) : '-' }}
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        header: Array,
        data: {
            types: [Object, Array],
            default() {
                return []
            }
        },
        colons: Boolean,
        keyTransformer: Function,
        valueTransformer: Function,
        keyClass: String,
        valueClass: String,
    },

    methods: {
        getTransformedKey(value) {
            if (this.keyTransformer) {
                return this.keyTransformer(value);
            }

            return value;
        },

        getTransformedValue(value) {
            if (this.valueTransformer) {
                return this.valueTransformer(value);
            }

            return value;
        }
    }
}
</script>
